<template>
    <div class="input input-checkbox">
        <a href="#" @click.prevent="getHelp" class="help-text" v-if="showHelpText">{{ helpText }}</a>
        <label class="checkbox">
            <input
                type="checkbox"
                :class="{ indeterminate: indeterminate }"
                v-model="boundValue"
                :value="value"
                :disabled="disabled"
            />
            <span class="label-text">{{ label }}</span>
        </label>
        <div class="input-error" v-for="(errorMessage, index) in errorMessages" :key="index">{{ errorMessages }}</div>
    </div>
</template>

<script>
export default {
    name: 'MtCheckbox',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        label: { type: String },
        value: {},
        errorMessage: { type: String },
        placeholder: { type: String },
        disabled: { type: Boolean },
        modelValue: {},
        indeterminate: { type: Boolean },
        helpText: {},
    },
    computed: {
        boundValue: {
            get() {
                return this.modelValue
            },
            set(v) {
                this.$emit('update:modelValue', v)
            },
        },
        errorMessages() {
            if (!this.errorMessage) {
                return []
            }

            return Array.isArray(this.errorMessage) ? this.errorMessage : [this.errorMessage]
        },
        showHelpText() {
            return this.helpText !== null && this.helpText !== undefined
        },
    },
    methods: {
        getHelp() {
            this.$emit('help')
        },
    },
}
</script>
<style>
.input-checkbox .help-text {
    float: right;
}
</style>
